module.exports = __webpack_public_path__ + "img/turbo_on.7c0a558a.png";